import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['expensePeriodUnit', 'splitEvenly', 'index', 'amount']);
  const createExpenseData = `createExpenseData(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createExpenseData} {
      id
    }
  }
`;
};
